import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ListEvidenceEffects, listEvidenceReducer, LIST_EVIDENCE_STORE_KEY } from './state';
import { ListEvidenceComponent } from './components/list-evidence/list-evidence.component';
import { SharedUiTablesModule } from '@shared/ui/tables';
import { SharedUiPageToolbarsModule } from '@shared/ui/page-toolbars';
import { SharedUiCardsModule } from '@shared/ui/cards';
import { SharedFeatureTranslateModule } from '@shared/feature/translate';
import { SharedUiDatetimeModule } from '@shared/ui/datetime';
import { SharedUiInputsModule } from '@shared/ui/inputs';
import { SharedFeatureListOfficerModule } from '@shared/feature/list-officer';
import { SharedFeatureLoadingModule } from '@shared/feature/loading';
import { SharedUiButtonsModule } from '@shared/ui/buttons';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(LIST_EVIDENCE_STORE_KEY, listEvidenceReducer),
    EffectsModule.forFeature([ListEvidenceEffects]),
    SharedFeatureListOfficerModule,
    SharedUiTablesModule,
    SharedUiPageToolbarsModule,
    SharedUiCardsModule,
    SharedFeatureTranslateModule,
    SharedUiDatetimeModule,
    SharedUiInputsModule,
    SharedFeatureLoadingModule,
    SharedUiButtonsModule,
  ],
  declarations: [ListEvidenceComponent],
  exports: [ListEvidenceComponent],
})
export class SharedFeatureListEvidenceModule {}
